var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.image_url
    ? _c("section", [
        _c("div", { staticClass: "top-banner" }, [
          _c("a", { attrs: { href: _vm.banner_link, target: "_blank" } }, [
            _c("img", {
              staticClass: "desktop-only",
              attrs: { src: _vm.image_url },
            }),
            _vm._v(" "),
            _vm.mobile_url
              ? _c("img", {
                  staticClass: "mobile-only",
                  attrs: { src: _vm.mobile_url },
                })
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }